import type { TOC } from '@ember/component/template-only'
import { DetailedPageWrapper } from 'district-ui-client/components/reporting/detailed-page-wrapper'
import { not } from 'ember-truth-helpers'
import type ReAwardsEarnedRoute from 'district-ui-client/reporting/ui-scope/re/awards-earned/route'
import { ChartsAwardsEarnedCertificatesByMonth } from 'district-ui-client/components/charts/awards-earned/certificates/by-month'
import fullGradeName from 'district-ui-client/helpers/full-grade-name'
import { t } from 'ember-intl'
import { PhosphorIcon } from 'district-ui-client/components/phosphor-icon'
import { Tooltip } from 'district-ui-client/components/tooltip'
import RouteTemplate from 'ember-route-template'

interface Signature {
  Args: {
    model: ModelFor<ReAwardsEarnedRoute>
  }
}

export const ReAwardsEarnedRouteTemplate: TOC<Signature> = <template>
  <DetailedPageWrapper @empty={{not @model.awardsEarnedTotals}}>
    {{#each @model.awardsEarnedTotals as |gradeData|}}
      <div class="detailed-chart-wrapper relative">
        <ChartsAwardsEarnedCertificatesByMonth
          data-test-awards-earned-certificates-totals
          class="h-full"
          @title={{t "reporting.chartTitles.awardsEarnedTotals.re"}}
          @product={{@model.product}}
          @data={{gradeData}}
          @grade={{fullGradeName gradeData.grade_position}}
          @yAxisTitle={{t "reporting.chartTitles.awardsEarnedTotals.re"}}
        />
        <span class="absolute right-0.5 top-0 print:hidden">
          <PhosphorIcon @icon="phosphor-info-fill" class="h-3.5 w-3.5 cursor-pointer text-dusty-black-500" />
          <Tooltip @text={{t "reporting.tooltips.awardsEarnedTotals.re" htmlSafe=true}} />
        </span>
      </div>
    {{/each}}
  </DetailedPageWrapper>
</template>

export default RouteTemplate(ReAwardsEarnedRouteTemplate)
